export const mantto = {
    en: {
        nav: {
            title: 'Maintenance',
            dashboard: 'Dashboard',
            schedule: 'Schedule',
            service: 'Service Log',
            errorcode: 'Error Codes'
        },
        pager: ['Page', 'of', 'Row(s) per page'],
        actions: {
            new: 'New',
            search: 'Search',
            save: 'Save changes',
            cancel: 'Cancel',
            edit: 'Edit',
            del: 'Delete',
            log: 'Log unrelated service',
            yes: 'Yes',
            report: 'Report'
        },
        measurements: [
            { value: 'MILES|HOURS|DAYS', text: 'All', alt: '', selected: false },
            { value: 'MILES', text: 'Miles', alt: 'Miles before scheduled', selected: false },
            { value: 'HOURS', text: 'Hours', alt: 'Hours before schedule', selected: false },
            { value: 'DAYS', text: 'Days', alt: 'Days earlier than scheduled', selected: false }
        ],
        types: [
            { value: 1, text: 'Air filter change' },
            { value: 2, text: 'Oil change' },
            { value: 3, text: 'Tire rotation' },
            { value: 4, text: '50,000 miles service' },
            { value: 5, text: 'Time up' }
        ],
        modals: {
            titles: [
                'Log Service',
                'Log New Service',
                'Log Other Service',
                'Edit Service'
            ],
            notes: [
                'Do you want to log a new service for an existing maintenance schedule?',
                'Complete to ensure the following reminders are sent on time for the next service. The reminder for this vehicle and maintenance type will be reset after selecting “save changes”'
            ]
        },
        dashboard: {
            prefix: ['By', 'In'],
            columns: [
                'Overdue',
                'Upcoming',
                'Vehicle/Assets',
                'Type of maintenance'
            ],
            note: 'A service reminder will not be reset until a service for that vehicle has been registered'
        },
        schedule: {
            headers: {
                h1: ['New service', 'Edit service'],
                h6: ['Alert Notifications', 'Additional reminders'],
                titles: ['New service', 'Edit service', 'Delete service'],
                subs: ['Alert Notifications', 'Additional reminders'],
                notes: [
                    'Configure the custom maintenance program below. You can adjust when the first alert will be sent by calculating when the last service was performed',
                    'By default, you will receive an alert when the chosen parameter has been activated. You can set additional reminders below. Only related measurements (miles with miles, days with days, hours with hours) will apply.',
                    'Do you want to delete _SCHEDULE_ from the list?',
                ],
                labels: ['Created', 'Updated']
            },
            forms: {
                device: {
                    label: 'Device',
                    placeholder: 'Select Device',
                    required: 'Device is required'
                },
                description: {
                    label: 'Type of maintenance',
                    placeholder: 'Ex. Oil change',
                    required: 'Description is required',
                    error: ''
                },
                emails: {
                    label: 'Send Notifications to (email or phone)',
                    placeholder: 'example@domain.com or 8888888888',
                    required: 'Email or phone is required',
                    error: 'Invalid email or invalid number (10 digits)'
                },
                frequency: {
                    label: 'Frequency',
                    placeholder: '',
                    required: 'Frequency is required',
                    error: 'Frequency must be a whole number or decimal'
                },
                measurement: {
                    label: 'Measurement',
                    placeholder: 'Select measurement',
                    required: 'Measurement is required'
                },
                last: {
                    label: 'Last service',
                    placeholder: 'Miles/hours/days',
                    required: 'Last service is required',
                    error: 'Last service must be a whole number or decimal'
                }
            },
            columns: {
                type: {
                    title: 'Type of maintenance',
                    placeholder: ['Ex. Oil change']
                },
                frequency: {
                    title: 'Frequency',
                    label: ['Occurs every'],
                    placeholder: ['Ex. 500.0 or 2', 'Measurement'],
                    help: '<strong>Miles</strong> must be a whole number or decimal (ex: 1000 or 1000.10); <strong>hours/days</strong> must be a whole number'
                },
                last: {
                    title: 'Last performed',
                    label: ['Last occured', 'ago', 'Will occur in', ''],
                    placeholder: ['Ex. 500.0 or 2']
                }
            },
            reminders: [
                { value: 'MBS', text: 'Miles before scheduled' },
                { value: 'DBS', text: 'Days earlier than scheduled' },
                { value: 'HBS', text: 'Hours before schedule' }
            ],
            notifications: {
                create: 'Schedule was created successfully',
                edit: 'Schedule was edited successfully',
                empty: 'Without maintenance programs',
                del: 'Schedule was deleted successfuly'
            },

            titles: ['Create schedule', 'Create the maintenance Schedule', 'Edit schedule', 'Edit the maintenance Schedule'],
            subtitles: ['Alert Notifications', 'Send reminders'],
            notes: ['By default, you will receive an alert when the chosen parameter has been activated. You can set additional reminders below.', 'Configure the custom maintenance program below. You can adjust when the first alert will be sent by calculating when the last service was performed'],

        },
        service: {
            title: 'Service History',
            new: 'New service',
            empty: 'No data',
            download: ['Excel', 'PDF'],
            columns: [
                'Vehicle',
                'Maintenance type',
                'Service date',
                'Cost',
                // 'Odometer',
                // 'Mi/Hrs/Days past Service',
                'Comments'
            ],
            forms: {
                device: {
                    label: 'Vehicle',
                    placeholder: 'Select Vehicle',
                    required: 'Vehicle is required'
                },
                maintenance: {
                    label: 'Maintenance type',
                    placeholder: 'Select Maintenance',
                    required: 'Maintenance is required',
                    error: 'There are no maintenance assigned to the device'
                },
                cost: {
                    label: 'Cost',
                    placeholder: 'Cost',
                    required: 'Cost is required'
                },
                odometer: {
                    label: 'Odometer at service',
                    placeholder: 'Odometer at service',
                    required: 'Odometer is required'
                },
                services: {
                    label: 'Miles/Hours/Days past since serviced',
                    placeholder: '500 miles',
                    required: 'Serviced is required',
                },
                comments: {
                    label: 'Comments',
                    placeholder: 'Comments',
                    required: 'Comments is required'
                },
                date: {
                    label: 'Date Performed',
                    placeholder: 'yyyy-mm-dd',
                    required: 'Date is required'
                },
            },
            notifications: {
                create: 'Service was created successfully',
                edit: 'Service was edited successfully',
                detele: 'Service was delete successfully',
                errors: {
                    log: 'Maintenance may no longer be available.'
                },
                confirm: 'Do you want to delete _LOG_ from the list?',
            }
        },
        errorcode: {
            title: 'Engine Error Log',
            note: 'This feature is only applicable to vehicles that have the OBD plugin device that have been configured to read error codes',
            columns: [
                'Vehicle',
                'Code',
                'Data Recorded'
            ],
            notifications: {
                delete: 'Error code was delete successfully'
            }
        }
    },
    es: {
        nav: {
            title: 'Mantenimiento',
            dashboard: 'Tablero',
            schedule: 'Horario',
            service: 'Servicio',
            errorcode: 'Códigos de error'
        },
        pager: ['Página', 'de', 'fila(s) por página'],
        actions: {
            search: 'Búsqueda',
            save: 'Guardar cambios',
            cancel: 'Cancelar',
            edit: 'Editar',
            del: 'Eliminar',
            log: 'Registrar servicio no relacionado',
            yes: 'Si',
            report: 'Reportar'
        },
        measurements: [
            { value: 'MILES|HOURS|DAYS', text: 'Todos', alt: '', selected: false },
            { value: 'MILES', text: 'Kilometros', alt: 'Kilometros antes de lo programado', selected: false },
            { value: 'HOURS', text: 'Horas', alt: 'Horas antes de lo programado', selected: false },
            { value: 'DAYS', text: 'Días', alt: 'Días antes de lo programado', selected: false }
        ],
        types: [
            { value: 1, text: 'Cambio de filtro de aire' },
            { value: 2, text: 'Cambio de aceite' },
            { value: 3, text: 'Rotación de llanta' },
            { value: 4, text: 'Servicio de 50,000 millas' },
            { value: 5, text: 'Tiempo hasta' }
        ],
        modals: {
            titles: [
                'Registro de Servicio',
                'Registro de nuevo servicio',
                'Registro de otro servicio',
                'Edición de Servicio'
            ],
            notes: [
                '¿Desea registrar un nuevo servicio para un programa de mantenimiento existente?',
                'Complete para asegurarse de que los siguientes recordatorios se envíen a tiempo para el próximo servicio. El recordatorio para este tipo de vehículo y mantenimiento se restablecerá después de seleccionar "guardar cambios"'
            ]
        },
        dashboard: {
            prefix: ['Por', 'En'],
            columns: [
                'Atrasado',
                'Próximo',
                'Vehículo/Activo',
                'Tipo de mantenimiento'
            ],
            note: 'Un recordatorio de servicio no se restablecerá hasta que se haya registrado un servicio para ese vehículo'
        },
        schedule: {
            headers: {
                h1: ['Nuevo servicio', 'Editar servicio'],
                h6: ['Notificaciones de Alertas', 'Recordatorios adicionales'],
                titles: ['Nuevo servicio', 'Editar servicio', 'Eliminar servicio'],
                subs: ['Alert Notifications', 'Aditional reminders'],
                notes: [
                    'Configure el programa de mantenimiento personalizado a continuación. Puede ajustar cuándo se enviará la primera alerta calculando cuándo se realizó el último servicio',
                    'De forma predeterminada, recibirá una alerta cuando se haya activado el parámetro elegido. Puede configurar recordatorios adicionales a continuación. ',
                    '¿Desea eliminar _SCHEDULE_ de la lista?'
                ],
                labels: ['Creado', 'Actualizado']
            },
            forms: {
                device: {
                    label: 'Dispositivo',
                    placeholder: 'Seleccionar dispositivo',
                    required: 'Dispositivo es requerido'
                },
                description: {
                    label: 'Tipo de mantenimiento',
                    placeholder: 'Ej. Cambio de aceite',
                    required: 'Descripción es requerido',
                    error: ''
                },
                emails: {
                    label: 'Enviar notificaciones a (email)',
                    placeholder: 'ejemplo@dominio.com',
                    required: 'Email es requerido',
                    error: 'Correo electrónico invalido'
                },
                frequency: {
                    label: 'Frecuencia',
                    placeholder: '',
                    required: 'Frecuencia es requerido',
                    error: 'Frecuencia debe ser número o decimal'
                },
                measurement: {
                    label: 'Medida',
                    placeholder: 'Seleccione medida',
                    required: 'Medida es requerido'
                },
                last: {
                    label: 'Último servicio',
                    placeholder: 'Millas/Horas/Días',
                    required: 'Último servicio es requerido',
                    error: 'Último servicio debe ser número o decimal'
                }
            },
            columns: {
                type: {
                    title: 'Tipo de mantenimiento',
                    placeholder: ['Ej. Cambio de aceite']
                },
                frequency: {
                    title: 'Frecuencia',
                    label: ['Ocurre cada'],
                    placeholder: ['Ej. 500.0 o 2', 'Medida'],
                    help: '<strong>Millas</strong> debe ser un número entero o decimal (ej: 1000 or 1000.10); <strong>horas/días</strong> deben ser números enteros'
                },
                last: {
                    title: 'Último servicio',
                    label: ['Hace', 'atrás', 'Ocurrirá en', ''],
                    placeholder: ['Ej. 500.0 o 2']
                }
            },
            reminders: [
                { value: 'MBS', text: 'Kilometros antes de lo programado' },
                { value: 'DBS', text: 'Días antes de lo programado' },
                { value: 'HBS', text: 'Horas antes de lo programado' }
            ],
            notifications: {
                create: 'Horario fue guardado exitosamente ',
                edit: 'Horario fue editado exitosamente',
                empty: 'Sin programas de mantenimiento',
				del: 'El horario fue eliminado exitosamente'
            },

            titles: ['Crear horario', 'Crear el programa de mantenimiento', 'Editar horario', 'Editar el programa de mantenimiento'],
            subtitles: ['Notificaciones Alertas', 'Enviar recordatorios'],
            notes: ['De forma predeterminada, recibirá una alerta cuando se haya activado el parámetro elegido. Puede configurar recordatorios adicionales a continuación.', 'Configure el programa de mantenimiento personalizado a continuación. Puede ajustar cuándo se enviará la primera alerta calculando cuándo se realizó el último servicio'],
        },
        service: {
            title: 'Historial de servicio',
            new: 'Nuevo servicio',
            empty: 'Sin datos',
            download: ['Excel', 'PDF'],
            columns: [
                'Vehículo',
                'Tipo de mantenimiento',
                'Fecha de servicio',
                'Costo',
                // 'Odómetro',
                // 'Km/Hrs/Días pasados',
                'Comentarios'
            ],
            forms: {
                device: {
                    label: 'Vehículo',
                    placeholder: 'Seleccionar vehiculo',
                    required: 'Vehículo es requerido'
                },
                maintenance: {
                    label: 'Tipo de mantenimiento',
                    placeholder: 'Seleccione mantenimiento',
                    required: 'Mantenimiento es requerido',
                    error: 'No existen mantenimientos asignados al dispositivo'
                },
                cost: {
                    label: 'Costo',
                    placeholder: 'Costo',
                    required: 'Costo es requerido'
                },
                odometer: {
                    label: 'Odómetro en servicio',
                    placeholder: 'Odómetro en servicio',
                    required: 'Odómetro es requerido'
                },
                services: {
                    label: 'Kilometros/Horas/Días pasados ​​desde que fue reparado',
                    placeholder: '500 Kilometros',
                    required: 'Reparado es requerido',
                },
                comments: {
                    label: 'Comentarios',
                    placeholder: 'Comentarios',
                    required: 'Comentarios es requerido'
                },
                date: {
                    label: 'Fecha de realización',
                    placeholder: 'yyyy-mm-dd',
                    required: 'Fecha es requerido'
                },
            },
            notifications: {
                create: 'Servicio fue creado exitosamente ',
                edit: 'Servicio fue editado exitosamente',
                detele: 'Servicio fue eliminado exitosamente',
                errors: {
                    log: 'Es posible que el mantenimiento ya no esté disponible'
                },
                confirm: '¿Desea eliminar _LOG_ de la lista?',
            }
        },
        errorcode: {
            title: 'Engine Error Codes Logs',
            note: 'Esta función solo se aplica a los vehículos que tienen el dispositivo de complemento OBD que se han configurado para leer códigos de error',
            columns: [
                'Vehículo',
                'Código',
                'Datos grabados'
            ],
            notifications: {
                detele: 'Servicio fue eliminado exitosamente'
            }
        }
    }
};
